import React, { useEffect, useState } from 'react';
import { TRACKING } from 'common/constants/constants';
import { BACKGROUND_TYPES, BackgroundContainer } from '../Background';
import { Flex } from '../base/layout-components';
import ButtonLine from './ButtonLine';
import * as TrackingService from 'common/services/tracking.service';
import Section from './Section';
import styled from 'styled-components';
import { __colors } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
const { zircon } = __colors;

const CloseIconWrapper = styled.div`
  position: absolute;
  top: 15rem;
  right: 2.4rem;
  width: 2.7rem;
  height: 2.7rem;
  background: ${zircon};
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CtaPage = props => {
  const {
    textsMap,
    page,
    pageTab: page_tab,
    buttonLineProps,
    backgroundImage,
    sections,
    onCloseClick
  } = props;
  const { textWidth, leftText, buttonText } = buttonLineProps;
  const [activeSection, setActiveSection] = useState(null);
  const clearSelection = () => setActiveSection(null);
  const onSectionButtonClick = sectionType => () => {
    setActiveSection(sectionType);
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page,
      page_tab,
      click_type: TRACKING.CLICK.CTA_IMAGE_POINTS,
      point: sectionType
    });
  };
  useEffect(() => {
    TrackingService.logEvent(TRACKING.EVENTS.VISIT, {
      page,
      page_tab
    });
  }, []);

  return (
    <BackgroundContainer
      {...props}
      type={BACKGROUND_TYPES.HIVE}
      justify='center'
      height='unset'
    >
      <Flex width='83.7rem' direction='column' items='center'>
        {onCloseClick && (
          <CloseIconWrapper>
            <Icon
              data-testid='close-icon-cta'
              name='CloseIcon'
              cursor='pointer'
              color={'dodgerBlue'}
              size='x-small'
              onClick={onCloseClick}
            />
          </CloseIconWrapper>
        )}

        <Flex margin='medium' mt='big' mb='small' position='relative'>
          <Flex width='83.75rem' height='49.45rem'>
            <img src={backgroundImage} alt='' width='100%' />
          </Flex>
          {sections.map(
            ({
              sectionType,
              buttonPosition,
              coverProps,
              textPosition,
              isTextLeft = false,
              isDummy,
              arrowLength
            }) => (
              <Section
                key={sectionType}
                clearSelection={clearSelection}
                initialMode={!activeSection}
                isActive={activeSection === sectionType}
                onButtonClick={onSectionButtonClick(sectionType)}
                buttonPosition={buttonPosition}
                coverProps={coverProps}
                textProps={{
                  text: textsMap[sectionType],
                  position: textPosition,
                  isLeft: isTextLeft
                }}
                isDummy={isDummy}
                arrowLength={arrowLength}
              />
            )
          )}
        </Flex>
        <ButtonLine
          textWidth={textWidth}
          leftText={leftText}
          buttonText={buttonText}
          onClickEvent={() =>
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              page,
              page_tab,
              click_type: TRACKING.CLICK.BOOK_A_DEMO
            })
          }
        />
      </Flex>
    </BackgroundContainer>
  );
};

export default CtaPage;
